import { OrderResponse } from "@sdk/shared/types/order.types";
import { timeLeftFromDate } from "@shared/src/utils/time";

export interface OrderTiemLeftParams {
  orderState: OrderResponse["state"];
  orderDuration: OrderResponse["duration"];
  orderExpiry: OrderResponse["expiry"];
}

export function getTargetDate({ orderState, orderDuration, orderExpiry }: OrderTiemLeftParams) {
  switch (orderState) {
    case "intent": {
      return new Date(orderExpiry * 1000);
    }
    case "pending":
    case "accepted": {
      return new Date(orderDuration * 1000);
    }
    default:
      return new Date();
  }
}
